import { useTranslations } from '@vocab/react';
import { Controller } from 'react-hook-form';

import type { FormValues } from 'src/pages/LinkYourSoftware/components/ContentState';
import { useIntegrationPartners } from 'src/utils/hooks/useIntegrationPartners';
import { chooseReleaseNotesPartners } from 'src/utils/partners';

import { RadioWithFollowUp } from '../RadioWithFollowUp/RadioWithFollowUp';

import lysTranslations from 'src/pages/LinkYourSoftware/.vocab';

export const FuturePosting = () => {
  const { t: lys } = useTranslations(lysTranslations);

  const releaseNotesPartners = chooseReleaseNotesPartners(
    useIntegrationPartners().partners,
  );

  const partnerList =
    releaseNotesPartners.state === 'data'
      ? releaseNotesPartners.data.map(({ name }) => name)
      : [];

  const radioOptions: [string, string] = [
    lys('advertiserCenter'),
    lys('throughAnotherRsp'),
  ];
  return (
    <Controller
      name="futurePosting"
      rules={{
        required: lys('selectOneOption'),
        validate: (value: FormValues['futurePosting']) => {
          if (value?.answer === radioOptions[1] && !value?.followUpAnswer) {
            return lys('selectOneOption');
          }
          return true;
        },
      }}
      render={({ field, fieldState }) => (
        <RadioWithFollowUp
          id="lys-future-posting"
          radioLabel={lys('postingJobs')}
          radioOptions={radioOptions}
          dropdownLabel={lys('whichRspToSeek')}
          dropdownOptions={partnerList}
          value={field.value}
          onChange={field.onChange}
          error={fieldState.invalid}
        />
      )}
    />
  );
};
